module.exports = __webpack_public_path__ + "static/media/tnSupremeCourt.638c4fc1.jpeg";